var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrevArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32.5,
    height: 32.5,
    rx: 16.25,
    fill: "#B30707"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31.5,
    height: 31.5,
    rx: 15.75,
    stroke: "white",
    strokeOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8549 21.8367C20.031 22.0128 20.13 22.2517 20.13 22.5008C20.13 22.7499 20.031 22.9888 19.8549 23.165C19.6788 23.3411 19.4399 23.4401 19.1908 23.4401C18.9416 23.4401 18.7027 23.3411 18.5266 23.165L12.2758 16.9142C12.1884 16.8271 12.119 16.7235 12.0717 16.6096C12.0244 16.4956 12 16.3734 12 16.25C12 16.1266 12.0244 16.0044 12.0717 15.8904C12.119 15.7765 12.1884 15.673 12.2758 15.5859L18.5266 9.33504C18.7027 9.15889 18.9416 9.05994 19.1908 9.05994C19.4399 9.05994 19.6788 9.15889 19.8549 9.33504C20.031 9.51118 20.13 9.75008 20.13 9.99919C20.13 10.2483 20.031 10.4872 19.8549 10.6633L14.269 16.2492L19.8549 21.8367Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevArrow);
export default __webpack_public_path__ + "static/media/prev-arrow.58745edefaf510005705e6e2e37f7827.svg";
export { ForwardRef as ReactComponent };